/* ==========================================================================
   GemofU — search
   Loaded site-wide from layout/theme.liquid.

   The complaint was "the search sucks, we have to type exact wording".
   Measured against the live store, here is what was actually wrong:

   1. THE DROPDOWN WAS DEAD. Forge lazy-loads each section's script when the
      section becomes visible. The search drawer starts at display:none, so
      section-predictive-search.js was NEVER loaded on any page - window.
      PredictiveSearch was undefined and the input had no listener attached.
      Typing in the search box therefore showed nothing at all, and the only
      way to see a product was to press Enter and hope. Loading that script
      the moment someone reaches for search turns the dropdown back on: typing
      "bangl" returns 13 products straight away. This is the main fix.

   2. PREFIX MATCHING WAS OFF. Shopify only does prefix matching when asked.
      options[prefix]=last is added to every search form and to the predictive
      request, so a half-typed word still matches.

   3. THERE WAS NO FALLBACK. A search that genuinely found nothing was a dead
      end. It now re-runs the query a few looser ways against the real search
      results (not the suggest endpoint, which is more forgiving and would
      have sent people to another empty page), and offers category chips if
      none of them help.

   Also injects the inline search bar on collection pages and the search icon
   in the mobile header.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Alias table ------------------------------------------------------
     Left side is what a shopper is likely to type. Right side is every form
     that appears in this catalogue - including "chocker", which is how the
     products are actually spelled. Matching is two-way.
     ---------------------------------------------------------------------- */
  var ALIASES = [
    ['choker', 'chocker', 'chockers'],
    ['jhumka', 'jhumkas', 'jhumki', 'jhumkka', 'jhimikki', 'jhumikki', 'jimikki'],
    ['chandbali', 'chandbalis', 'chaandbali'],
    ['mangalsutra', 'mangalsutras', 'thali', 'thaali'],
    ['haram', 'haaram', 'harams'],
    ['attigai', 'addigai', 'adigai'],
    ['guttappusalu', 'guttapusalu'],
    ['maang', 'mang', 'tikka', 'tika'],
    ['bugadi', 'bugadis', 'bugdi'],
    ['earring', 'earrings', 'earstud', 'earstuds', 'studs', 'stud'],
    ['earcuff', 'earcuffs', 'cuff', 'cuffs'],
    ['bangle', 'bangles', 'kada'],
    ['necklace', 'necklaces', 'neckpiece', 'neckwear'],
    ['pendant', 'pendants', 'locket'],
    ['bracelet', 'bracelets'],
    ['cz', 'cubic', 'zirconia', 'zircon'],
    ['kemp', 'kempu', 'temple'],
    ['moissanite', 'moissonite', 'moisanite'],
    ['antique', 'oxidised', 'oxidized', 'matte'],
    ['emerald', 'green'],
    ['ruby', 'red'],
    ['pearl', 'pearls', 'moti'],
    ['set', 'sets', 'combo'],
    ['bridal', 'wedding'],
    ['gold', 'golden'],
    ['silver', 'rhodium']
  ];

  var ALIAS_MAP = (function () {
    var map = {};
    ALIASES.forEach(function (group) {
      group.forEach(function (word) {
        map[word] = map[word] || [];
        group.forEach(function (other) {
          if (map[word].indexOf(other) === -1) map[word].push(other);
        });
      });
    });
    return map;
  })();

  var STOPWORDS = ['a', 'an', 'the', 'for', 'with', 'and', 'of', 'in', 'my'];

  function terms(query) {
    return String(query || '')
      .toLowerCase()
      .replace(/[^\w\s'-]+/g, ' ')
      .split(/\s+/)
      .filter(function (t) { return t && STOPWORDS.indexOf(t) === -1; });
  }

  /* ---- 1. Turn the predictive dropdown on ------------------------------- */
  function bootPredictive(ctx) {
    if (!window.PredictiveSearch || typeof window.PredictiveSearch.init !== 'function') return false;
    if (ctx.hasAttribute('data-gou-predictive-ready')) return true;
    ctx.setAttribute('data-gou-predictive-ready', '');
    try { window.PredictiveSearch.init(ctx); } catch (e) { /* leave the form working */ }
    return true;
  }

  function ensurePredictive() {
    var ctx = document.getElementById('predictiveSearch');
    if (!ctx || ctx.hasAttribute('data-gou-predictive-ready')) return;

    // Already on the page (another section pulled it in) - just wire it up.
    if (window.PredictiveSearch) { bootPredictive(ctx); return; }

    var url = ctx.dataset.assetUrl;
    if (!url) return;

    if (document.querySelector('script[data-gou-predictive-src]')) return;

    var s = document.createElement('script');
    s.src = url;
    s.setAttribute('data-gou-predictive-src', '');
    // The file self-initialises every [data-section-type="predictive-search"]
    // at the bottom, so on load it only needs marking, not calling again -
    // calling init twice would double-bind the input and fire two requests.
    s.onload = function () { ctx.setAttribute('data-gou-predictive-ready', ''); };
    document.head.appendChild(s);
  }

  function bindPredictiveTriggers() {
    // Anything that means "I am about to search".
    ['focusin', 'pointerdown', 'touchstart'].forEach(function (evt) {
      document.addEventListener(evt, function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        if (t.closest('input[name="q"], [data-wau-slideout-target="searchbox"], .gou-mobile-search-trigger, .header__cart-links--search, .gou-inline-search')) {
          ensurePredictive();
        }
      }, { capture: true, passive: true });
    });
  }

  /* ---- 2. Prefix matching on every search form -------------------------- */
  function armForm(form) {
    if (!form || form.hasAttribute('data-gou-search-armed')) return;

    var action = (form.getAttribute('action') || '');
    if (action.indexOf('/search') === -1) return;

    form.setAttribute('data-gou-search-armed', '');

    if (!form.querySelector('input[name="options[prefix]"]')) {
      var prefix = document.createElement('input');
      prefix.type = 'hidden';
      prefix.name = 'options[prefix]';
      prefix.value = 'last';
      form.appendChild(prefix);
    }

    // Search pages and articles too, so "shipping" or "returns" lands
    // somewhere useful instead of on an empty product grid.
    if (!form.querySelector('input[name="type"]')) {
      var type = document.createElement('input');
      type.type = 'hidden';
      type.name = 'type';
      type.value = 'product,page,article';
      form.appendChild(type);
    }
  }

  function armAllForms() {
    document.querySelectorAll('form[action*="/search"]').forEach(armForm);
  }

  // section-predictive-search.js builds its own URL and does not pass the
  // prefix option, so the dropdown would be stricter than the results page.
  // Patch the request rather than forking the theme file.
  function patchPredictiveFetch() {
    if (window.__gouFetchPatched) return;
    window.__gouFetchPatched = true;

    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function') return;

    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url);
        if (url && url.indexOf('section_id=predictive-search') !== -1 && url.indexOf('prefix') === -1) {
          var extra = '&resources[type]=product,collection,page,article' +
                      '&resources[limit]=6' +
                      '&resources[options][prefix]=last' +
                      '&resources[options][unavailable_products]=last';
          if (typeof input === 'string') {
            input = url + extra;
          } else {
            input = new Request(url + extra, input);
          }
        }
      } catch (e) { /* fall through to the untouched request */ }
      return nativeFetch.call(this, input, init);
    };
  }

  /* ---- 3. Inline search bar under the page heading ---------------------- */
  var SEARCH_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<circle cx="11" cy="11" r="7"></circle>' +
    '<path d="M20 20l-4.2-4.2"></path></svg>';

  function searchRoot() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (base.replace(/\/$/, '') + '/search');
  }

  function buildInlineSearch(placeholder) {
    var wrap = document.createElement('div');
    wrap.className = 'gou-inline-search';
    wrap.innerHTML =
      '<form class="gou-inline-search__form" action="' + searchRoot() + '" method="get" role="search">' +
        '<label class="visually-hidden" for="gou-inline-q">Search</label>' +
        '<input class="gou-inline-search__input" id="gou-inline-q" type="search" name="q" autocomplete="off" ' +
          'placeholder="' + placeholder + '">' +
        '<button class="gou-inline-search__submit" type="submit" aria-label="Search">' + SEARCH_ICON + '</button>' +
      '</form>';
    armForm(wrap.querySelector('form'));
    return wrap;
  }

  function injectInlineSearch() {
    var body = document.body;
    if (!body) return;

    var isCollection = /\btemplate-collection\b|\btemplate-list-collections\b/.test(body.className);
    var is404 = /\btemplate-404\b/.test(body.className);
    if (!isCollection && !is404) return;
    if (document.querySelector('.gou-inline-search')) return;

    var caption = document.querySelector('.template-header .section__banner-caption, .collection-header .section__banner-caption');
    if (!caption) return;

    caption.appendChild(buildInlineSearch(
      isCollection ? 'Search necklaces, bangles, earrings…' : 'Search the shop…'
    ));
  }

  /* ---- 3b. Mobile header search icon ------------------------------------
     The permanent search strip under the mobile header has been switched off
     (mobile-header > Show searchbox), because it added a whole second row to
     an already tall header. A search icon goes into the icon row instead and
     opens the same drawer the desktop header uses - same predictive results,
     no extra markup to maintain.
     ---------------------------------------------------------------------- */
  function injectMobileSearchIcon() {
    document.querySelectorAll('.section-header__mobile ul').forEach(function (ul) {
      if (ul.querySelector('.gou-mobile-search-li')) return;
      if (!ul.querySelector('.mobile-header__cart-links--account, .mobile-header__cart-links--cart')) return;

      var li = document.createElement('li');
      li.className = 'gou-mobile-search-li mobile-header__cart-links--search relative';
      li.innerHTML =
        '<div class="slideout__trigger--open lh0">' +
          '<a class="gou-mobile-search-trigger js-slideout-open" ' +
             'data-wau-slideout-target="searchbox" data-slideout-direction="right" ' +
             'href="' + searchRoot() + '" aria-label="Search">' + SEARCH_ICON +
          '</a>' +
        '</div>';

      ul.insertBefore(li, ul.firstChild);
    });
  }

  /* ---- 4. Fallback when a search returns nothing ------------------------ */
  var SUGGESTIONS = ['Necklaces', 'Bangles', 'Earrings', 'Mangalsutra', 'Ear Studs', 'Chocker'];

  function sectionId() {
    var el = document.getElementById('main-search-results');
    return el ? el.dataset.id : null;
  }

  // Counted against the REAL search results, not /search/suggest.json - the
  // suggest endpoint is much more forgiving, so trusting it would send people
  // to a second empty page.
  function countFor(query) {
    var id = sectionId();
    var url = searchRoot() + '?q=' + encodeURIComponent(query) +
              '&options%5Bprefix%5D=last&type=product' +
              (id ? '&section_id=' + encodeURIComponent(id) : '');

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return 0;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelectorAll('.product-loop__item, .product-index').length;
      })
      .catch(function () { return 0; });
  }

  // Progressively looser rewrites. First one that finds stock wins.
  function candidates(original) {
    var list = [];
    var t = terms(original);
    if (!t.length) return list;

    list.push(t.map(function (w) { return w + '*'; }).join(' '));

    var expanded = t.map(function (w) {
      var alts = ALIAS_MAP[w];
      if (!alts || alts.length < 2) return w + '*';
      return alts.map(function (a) { return a + '*'; }).join(' OR ');
    });
    if (expanded.join(' ') !== list[0]) list.push(expanded.join(' '));

    if (t.length > 1) {
      var longest = t.slice().sort(function (a, b) { return b.length - a.length; })[0];
      var alts = ALIAS_MAP[longest];
      list.push(alts && alts.length > 1
        ? alts.map(function (a) { return a + '*'; }).join(' OR ')
        : longest + '*');
    }

    var stem = t.slice().sort(function (a, b) { return b.length - a.length; })[0];
    if (stem && stem.length > 4) list.push(stem.slice(0, 4) + '*');

    return list.filter(function (q, i) { return q && list.indexOf(q) === i; });
  }

  function resultsCount() {
    var grid = document.querySelector('#main-search-results .product-loop, .search__page--wrapper .product-loop');
    if (grid) return grid.querySelectorAll('.product-loop__item, .product-index').length;
    return document.querySelector('.search--empty') ? 0 : -1;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderNote(html) {
    var wrapper = document.getElementById('searchResultsWrapper');
    if (!wrapper) return;
    var existing = wrapper.querySelector('.gou-search-note');
    if (existing) existing.remove();

    var note = document.createElement('p');
    note.className = 'gou-search-note';
    note.innerHTML = html;

    var bar = wrapper.querySelector('#search-bar');
    if (bar && bar.nextSibling) wrapper.insertBefore(note, bar.nextSibling);
    else wrapper.insertBefore(note, wrapper.firstChild);
  }

  function renderSuggestionChips() {
    var wrapper = document.getElementById('searchResultsWrapper');
    if (!wrapper || wrapper.querySelector('.gou-search-suggestions')) return;

    var ul = document.createElement('ul');
    ul.className = 'gou-search-suggestions';
    ul.innerHTML = SUGGESTIONS.map(function (s) {
      return '<li><a href="' + searchRoot() + '?q=' + encodeURIComponent(s) +
             '&options%5Bprefix%5D=last">' + s + '</a></li>';
    }).join('');

    var empty = wrapper.querySelector('.search--empty');
    if (empty) empty.appendChild(ul);
    else wrapper.appendChild(ul);
  }

  function handleSearchPage() {
    if (!/\btemplate-search\b/.test(document.body.className)) return;

    var p = new URLSearchParams(window.location.search);
    var q = p.get('q');
    if (!q) return;

    var cameFrom = p.get('gou_from');
    if (cameFrom) {
      renderNote(
        'Nothing matched <strong>' + escapeHtml(cameFrom) + '</strong>. ' +
        'Showing the closest matches instead.'
      );
      return;
    }

    if (resultsCount() !== 0) return;

    var list = candidates(q);
    if (!list.length) { renderSuggestionChips(); return; }

    renderNote('Looking for close matches…');

    (function next(i) {
      if (i >= list.length) {
        renderNote('No results for <strong>' + escapeHtml(q) + '</strong>. Try one of these:');
        renderSuggestionChips();
        return;
      }
      countFor(list[i]).then(function (n) {
        if (n > 0) {
          window.location.replace(
            searchRoot() +
            '?q=' + encodeURIComponent(list[i]) +
            '&options%5Bprefix%5D=last' +
            '&type=product,page,article' +
            '&gou_from=' + encodeURIComponent(q)
          );
        } else {
          next(i + 1);
        }
      });
    })(0);
  }

  /* ---- Wiring ----------------------------------------------------------- */
  function sweep() {
    armAllForms();
    injectMobileSearchIcon();
    injectInlineSearch();
  }

  function start() {
    patchPredictiveFetch();
    bindPredictiveTriggers();
    sweep();
    handleSearchPage();

    // The dropdown is the main fix, so do not wait for a click: warm it once
    // the page is otherwise idle.
    if (window.requestIdleCallback) {
      window.requestIdleCallback(ensurePredictive, { timeout: 3000 });
    } else {
      setTimeout(ensurePredictive, 1500);
    }

    if (document.body) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(sweep, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function () {
    sweep();
    ensurePredictive();
  });
})();
